<template>
  <div class="key-infos">
    <KeyInfo
      v-for="item in items"
      :key="item.label"
      :icon="item.icon"
    >
      <template #label>
        <FormulaTooltip
          v-if="item.formula"
          :formula="item.formula"
          :entity-external-id="entityExternalId"
        >
          {{ item.label }}
        </FormulaTooltip>
        <span v-else>
          {{ item.label }}
        </span>
      </template>
      <template #main>
        <div
          v-if="loading"
          class="loading-zone"
        >
          <Loader />
        </div>
        <Title
          v-else
          resize="8"
        >
          <span v-if="item.value">
            {{ formatCurrency(item.value) }}
          </span>
          <span
            v-else
            class="stk-color-text-weak"
          >
            N/A
          </span>
        </Title>
      </template>
    </KeyInfo>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { KeyInfo, Title, Loader } from '@stakeui';
import { formatCurrency } from '@frontend/shared/Util.js';
import FormulaTooltip from '@frontend/ui/components/FormulaTooltip.vue';

const props = defineProps({
  client: {
    type: Object,
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  entityExternalId: {
    type: String,
    required: true,
  },
});

const totalAnnualIncome = computed(() => props.client?.total_annual_income);
const totalMonthlyIncome = computed(() => props.client?.total_monthly_income);
const totalMonthlyExpenses = computed(() => props.client?.total_monthly_expenses);
const monthlyCashFlow = computed(() => props.client?.monthly_cash_flow);
const netWorth = computed(() => props.client?.net_worth);

const formulas = computed(() => props.client?._formulas || {});

const items = computed(() => ([
  {
    icon: 'fas fa-calendar',
    label: 'Annual Income',
    value: totalAnnualIncome.value,
    formula: formulas.value.total_annual_income,
  },
  {
    icon: 'fas fa-arrow-down',
    label: 'Monthly Income',
    value: totalMonthlyIncome.value,
    formula: formulas.value.total_monthly_income,
  },
  {
    icon: 'fas fa-arrow-up',
    label: 'Monthly Expenses',
    value: totalMonthlyExpenses.value,
    formula: formulas.value.total_monthly_expenses,
  },
  {
    icon: 'fas fa-money-bill',
    label: 'Monthly Cash Flow',
    value: monthlyCashFlow.value,
    formula: formulas.value.monthly_cash_flow,
  },
  {
    icon: 'fas fa-coins',
    label: 'Net Worth',
    value: netWorth.value,
    formula: formulas.value.net_worth,
  },
]));
</script>

<style lang="css" scoped>
.key-infos {
  display: flex;
  align-items: start;
  gap: 2rem;
  justify-content: space-between;
}

/* To match the height of the Title size 8 */
.loading-zone {
  color: var(--stk-border);
  height: calc(calc(0.25rem * 8) * 1.125);
  display: flex;
  align-items: center;
}
</style>
